import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { API_BASE_URL } from "../../../api/api";
import { toast } from "react-toastify";
import { CONSTANT_REDIRECT_TIME, getGender } from "../../../constant/common";
import { formatDateForView } from "../../../utils/formateDate";
import { StarRating } from "../../common/StarRating";
import FAQComponent from "../../common/practice/FAQComponent";
import { getInitials, getPracticeMapUrl } from "../../../utils/helper";
import PracticeReviewsCard from "../../frontend/reviews/PracticeReviewsCard";
import { PhotoProvider, PhotoView } from "react-photo-view";

const PractitionerDetailsCard = ({ practitionerDetails, getPractitionersList }) => {
    const [practiceactiveTab, setPracticeActiveTab] = useState("overview");

    // FAQs Tab
    const [activeFaqIndex, setActiveFaqIndex] = useState(null);
    const [searchFaqTerm, setSearchFaqTerm] = useState("");
    const filteredFaqs = (practitionerDetails?.faqs || []).filter((faq) =>
        faq?.question?.toLowerCase().includes(searchFaqTerm.toLowerCase())
    );

    const handleImageChange = async (e) => {
        if (e.target.files && e.target.files.length > 0) {
            const file = e.target.files[0];

            const payload = {
                practices_id: practitionerDetails?.practices_id,
                image: file,
            };

            try {
                const response = await api.post("update-practices-image", payload, {
                    headers: { "Content-Type": "multipart/form-data" },
                });

                if (response?.data?.status === true) {
                    toast.success(response.data?.message);

                    if (getPractitionersList) {
                        setTimeout(() => {
                            getPractitionersList();
                        }, CONSTANT_REDIRECT_TIME);
                    }

                } else {
                    toast.error(response?.data?.message || "Failed ");
                    return null;
                }
            } catch (error) {
                console.error("Error :", error);
                toast.error("Something went wrong. Please try again.");
                return null;
            }
        } else {
            console.log("No file selected.");
        }
    };

    const itemsPerPage = 10;

    const [currentReviewPage, setCurrentReviewPage] = useState(1);

    const totalReviewPages = Math.ceil((practitionerDetails?.reviews?.length || 0) / itemsPerPage);

    const paginatedReviewData =
        practitionerDetails?.reviews?.length > 0
            ? practitionerDetails?.reviews.slice(
                (currentReviewPage - 1) * itemsPerPage,
                currentReviewPage * itemsPerPage
            )
            : [];

    const handleReviewPageChange = (newPage) => {
        if (newPage > 0 && newPage <= totalReviewPages) {
            setCurrentReviewPage(newPage);
        }
    };

    return (
        <>
            <div className="px-4 py-4 sm:px-[30px] sm:py-[30px] md:px-[60px] md:py-[60px] bg-white rounded-[18px]">
                <div className="mb-4 md:mb-6 lg:mb-10 flex flex-wrap gap-y-3">
                    <div className="w-full md:w-[calc(100%-170px)] flex flex-wrap gap-y-3 listcardwrapper">
                        <div className="w-[100px] sm:w-[170px] w-100 imgcard">
                            <div>
                            {practitionerDetails?.image ? (
                                <img src={practitionerDetails?.image ? API_BASE_URL + practitionerDetails?.image : null} alt="" className="w-full rounded-lg aspect-square object-cover mb-1.5" />
                            ) : (
                                <div className="w-full rounded-lg aspect-square object-cover mb-1.5 bg-gray-200 flex items-center justify-center text-5xl overflow-hidden font-semibold text-gray-700">
                                    {practitionerDetails?.practice_name && getInitials(practitionerDetails?.practice_name)}
                                </div>
                            )}
                            </div>
                            {/* <label htmlFor={`practitioner_${practitionerDetails?.practices_id}`} className=" py-2 bg-transparent text-dark border border-dark text-xs sm:text-base w-full flex items-center justify-center font-semibold rounded border-solid max-w-[130px] mx-auto cursor-pointer">Add Logo</label>
                            <input type="file" name="" id={`practitioner_${practitionerDetails?.practices_id}`} className="hidden" onChange={handleImageChange} /> */}
                        </div>
                        <div className="w-[calc(100%-100px)] sm:w-[calc(100%-170px)] px-3 sm:px-6 contentcard">
                            <div className="sm:max-w-[406px] w-100">
                                <div className="text-lg sm:text-xl md:text-2xl block w-fit font-semibold text-gray-800 mb-1 sm:mb-2 ">
                                    <span>{practitionerDetails?.practice_name}</span>
                                    {practitionerDetails?.is_verified == 1
                                        &&
                                        <span className="float-right mt-1 pl-2">
                                            <img src="/assets/image/verifiedicon.svg" alt="" srcSet="" />
                                        </span>
                                    }

                                </div>
                                <div className="flex items-center flex-wrap gap-x-3 gap-y-1 mb-2 sm:mb-4">
                                    <StarRating rating={Number(practitionerDetails?.reviews_avg) || 0} reviews_count={practitionerDetails?.reviews_count} />
                                </div>
                                {
                                    practitionerDetails?.address &&
                                    <Link
                                        to={getPracticeMapUrl(practitionerDetails)}
                                        target="_blank" rel="noopener noreferrer" className="flex gap-x-2 sm:gap-x-3 gap-y-1 sm:items-center mb-2 sm:mb-3">
                                        <svg width="24" className="w-4 h-4 sm:w-6 sm:h-6 mt-1 sm:mt-0" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M18.364 17.364L12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364ZM12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13Z" fill="#0052CC" />
                                        </svg>
                                        <span className="text-dark text-sm sm:text-base font-medium underline underline-offset-[2px] w-[calc(100%-24px)] sm:w-[calc(100%-36px)]">{practitionerDetails?.address}, {practitionerDetails?.suburb?.name} {practitionerDetails?.state?.name} {practitionerDetails?.postcode?.postcode}</span>
                                    </Link>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="w-full md:w-[170px] flex flex-wrap lg:flex-col lg:items-start lg:justify-center gap-2 sm:gap-3">
                        <Link to={`tel:${practitionerDetails?.phone}`} className="bg-green text-center text-white text-sm sm:text-base font-semibold md:w-full  rounded-lg py-2 px-3 sm:py-3  sm:px-2 flex items-center justify-center border border-green">Call {practitionerDetails?.practice_name}</Link>
                        <Link to={`mailto:${practitionerDetails?.email}`} className="bg-transparent text-center text-dark text-sm sm:text-base font-semibold md:w-full  rounded-lg py-2 px-3 sm:py-3 sm:px-2 flex items-center justify-center border border-dark emailButton">Email {practitionerDetails?.practice_name}</Link>
                        {practitionerDetails?.book_appointment_link && 
                        <Link                                                        
                        to={
                            practitionerDetails?.book_appointment_link
                            ? practitionerDetails?.book_appointment_link.startsWith("http://") || practitionerDetails?.book_appointment_link.startsWith("https://")
                                ? practitionerDetails?.book_appointment_link
                                : `https://${practitionerDetails?.book_appointment_link}`
                            : "#"
                        }
                        target="_black" className="bg-transparent text-center text-dark text-sm sm:text-base font-semibold md:w-full  rounded-lg py-2 px-3 sm:py-3  sm:px-2 flex items-center justify-center border border-dark">Book Appointment </Link>}
                        {practitionerDetails?.website_link && 
                        <Link                                                        
                        to={
                            practitionerDetails?.website_link
                            ? practitionerDetails?.website_link.startsWith("http://") || practitionerDetails?.website_link.startsWith("https://")
                                ? practitionerDetails?.website_link
                                : `https://${practitionerDetails?.website_link}`
                            : "#"
                        }
                        target="_black" className="bg-transparent text-center text-dark text-sm sm:text-base font-semibold md:w-full  rounded-lg py-2 px-3 sm:py-3  sm:px-2 flex items-center justify-center border border-dark">View Website </Link>}
                    </div>
                </div>
                <div className="tab-container">
                    <div className="tab-btn p-1.5 flex flex-wrap lg:justify-between bg-[#f5f5f5] rounded-lg gap-3 w-full max-w-[850px]">
                        <button
                            onClick={() => setPracticeActiveTab('overview')}
                            className={`px-5 py-2 text-base font-semibold rounded ${practiceactiveTab === "overview" ? "bg-blue text-white" : "bg-transparent text-dark"}`}>Overview</button>
                        <button
                            onClick={() => setPracticeActiveTab('reviews')}
                            className={`px-5 py-2 text-base font-semibold rounded ${practiceactiveTab === "reviews" ? "bg-blue text-white" : "bg-transparent text-dark"}`}>Reviews</button>
                        <button
                            onClick={() => setPracticeActiveTab('services_fees')}
                            className={`px-5 py-2 text-base font-semibold rounded ${practiceactiveTab === "services_fees" ? "bg-blue text-white" : "bg-transparent text-dark"}`}>Services & Fees</button>
                        <button
                            onClick={() => setPracticeActiveTab('photos')}
                            className={`px-5 py-2 text-base font-semibold rounded ${practiceactiveTab === "photos" ? "bg-blue text-white" : "bg-transparent text-dark"}`}>Photos</button>
                        <button
                            onClick={() => setPracticeActiveTab('faqs')}
                            className={`px-5 py-2 text-base font-semibold rounded ${practiceactiveTab === "faqs" ? "bg-blue text-white" : "bg-transparent text-dark"}`}>FAQs</button>
                        {/* <button
                            onClick={() => setPracticeActiveTab('more_details')}
                            className={`px-5 py-2 text-base font-semibold rounded ${practiceactiveTab === "more_details" ? "bg-blue text-white" : "bg-transparent text-dark"}`}>More Details</button> */}
                    </div>

                    <div className="tab-content rounded-lg pt-6">
                        {practiceactiveTab === "overview" &&
                            <div className="">
                                <p className="text-dark text-sm font-medium mb-3 last:mb-0 text-justify">{practitionerDetails?.full_description}</p>
                            </div>
                        }
                        {practiceactiveTab === "reviews" &&
                            <div className="">
                                {paginatedReviewData?.length > 0 && paginatedReviewData.map((review, index) => (
                                    <PracticeReviewsCard item={review} practice={practitionerDetails}/>
                                ))}

                                {paginatedReviewData?.length > 0 && (
                                    <div className="px-3 py-3 border-t-2 border-solid border-[#dfdfdf]">
                                        <ul className="flex items-center -space-x-px h-10 text-base justify-end">
                                            {/* Previous Button */}
                                            <li>
                                                <button
                                                    onClick={() => handleReviewPageChange(currentReviewPage - 1)}
                                                    disabled={currentReviewPage === 1}
                                                    className={`flex items-center justify-center px-4 h-10 ms-0 leading-tight border border-e-0 rounded-s-lg border-[#73aeff] ${currentReviewPage === 1 ? "text-gray-400 bg-gray-200 cursor-not-allowed" : "text-blue bg-gray-200 hover:bg-gray-100"}`}
                                                >
                                                    <svg className="w-3 h-3 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                                                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 1 1 5l4 4"></path>
                                                    </svg>
                                                </button>
                                            </li>

                                            {/* Dynamic Pagination Logic */}
                                            {Array.from({ length: totalReviewPages }, (_, i) => i + 1)
                                                .filter((page) => {
                                                    return (
                                                        page === 1 ||
                                                        page === totalReviewPages ||
                                                        (page >= currentReviewPage - 1 && page <= currentReviewPage + 1)
                                                    );
                                                })
                                                .reduce((acc, page, index, arr) => {
                                                    if (index > 0 && page !== arr[index - 1] + 1) {
                                                        acc.push("...");
                                                    }
                                                    acc.push(page);
                                                    return acc;
                                                }, [])
                                                .map((page, index) => (
                                                    <li key={index}>
                                                        {page === "..." ? (
                                                            <span className={`flex items-center justify-center px-4 h-10 leading-tight border border-[#73aeff] bg-gray-200 text-blue`}>...</span>
                                                        ) : (
                                                            <button
                                                                onClick={() => handleReviewPageChange(page)}
                                                                className={`flex items-center justify-center px-4 h-10 leading-tight border border-[#73aeff] ${currentReviewPage === page ? "bg-white text-blue" : "bg-gray-200 text-blue hover:bg-gray-100"}`}
                                                            >
                                                                {page}
                                                            </button>
                                                        )}
                                                    </li>
                                                ))}

                                            {/* Next Button */}
                                            <li>
                                                <button
                                                    onClick={() => handleReviewPageChange(currentReviewPage + 1)}
                                                    disabled={currentReviewPage === totalReviewPages}
                                                    className={`flex items-center justify-center px-4 h-10 leading-tight border rounded-e-lg border-[#73aeff] ${currentReviewPage === totalReviewPages ? "text-gray-400 bg-gray-200 cursor-not-allowed" : "text-blue bg-gray-200 hover:bg-gray-100"}`}
                                                >
                                                    <svg className="w-3 h-3 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                                                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4"></path>
                                                    </svg>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                )}
                            </div>
                        }

                        {practiceactiveTab === "services_fees" &&
                            <div className="">
                                <h3 className="text-dark text-lg font-semibold mb-4">Services & Fees</h3>
                                <ul className="space-y-3">
                                    <li className="text-dark flex flex-wrap items-center"><span className="font-semibold text-base min-w-56">Services :</span>
                                        <span>
                                            {practitionerDetails?.services?.map(service => service.name).join(", ")}
                                        </span>
                                    </li>
                                    {/* <li className="text-dark flex flex-wrap items-center"><span className="font-semibold text-base min-w-56">Servicing Areas :</span>
                                        <span> {practitionerDetails?.services_areas?.map(services_area => services_area.postcode).join(", ")}</span>
                                    </li> */}
                                    <li className="text-dark flex flex-wrap items-start">
                                        <span className="font-semibold text-base min-w-56">Service & Fees :</span>
                                        <div className="space-y-2">
                                            {practitionerDetails?.services_fees.length > 0 ?
                                                <>
                                                    {practitionerDetails?.services_fees.map((item, index) => <p key={index}>{item?.name} - {item?.fees}</p>)}
                                                </>
                                                : null
                                            }
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        }

                        {practiceactiveTab === "photos" &&
                            <div className="">
                                <PhotoProvider>
                                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 photoGallery">
                                        {practitionerDetails?.practices_images?.length > 0 && practitionerDetails?.practices_images.map((image_item, index) => (
                                            <PhotoView key={index} src={image_item?.image_url ? API_BASE_URL + image_item?.image_url : null}>
                                                <img src={image_item?.image_url ? API_BASE_URL + image_item?.image_url : null} alt="Gallery" className="w-full object-cover aspect-[175/111] rounded-lg cursor-pointer" />
                                            </PhotoView>
                                        ))}
                                    </div>
                                </PhotoProvider>
                            </div>
                        }


                        {practiceactiveTab === "faqs" &&
                            <div className="">
                                <div className="mb-6 relative w-full max-w-[630px] mx-auto">
                                    <div className="absolute left-[30px] top-1/2 -translate-y-1/2 w-6 h-6 z-10">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M23.6625 22.0027L16.8 15.1402C18.0797 13.4996 18.7688 11.4746 18.7688 9.39805C18.7688 4.22305 14.5594 0.0136719 9.38438 0.0136719C4.20937 0.0136719 0 4.22305 0 9.39805C0 14.573 4.20937 18.7824 9.38438 18.7824C11.4797 18.7824 13.5141 18.084 15.1594 16.7902L22.0172 23.648C22.4906 24.084 23.2219 24.0512 23.6578 23.5777C24.0656 23.1324 24.0656 22.448 23.6625 22.0027ZM2.32031 9.39805C2.32031 5.50273 5.48906 2.33867 9.37969 2.33867C13.2703 2.33867 16.4391 5.50742 16.4391 9.39805C16.4391 13.2887 13.2703 16.4574 9.37969 16.4574C5.48906 16.4574 2.32031 13.2887 2.32031 9.39805Z"
                                                fill="#0052CC"
                                            />
                                        </svg>
                                    </div>
                                    <input
                                        type="search"
                                        className="py-[14px] w-full text-dark text-lg pl-[68px] pr-[30px] bg-[#f5f5f5] rounded-lg focus:border-blue outline-none relative"
                                        placeholder="Search for a question"
                                        value={searchFaqTerm}
                                        onChange={(e) => setSearchFaqTerm(e.target.value)}
                                    />
                                </div>
                                {filteredFaqs.length > 0 ? (
                                    filteredFaqs.map((faq, index) => (
                                        <FAQComponent
                                            key={index}
                                            faq={faq}
                                            isOpen={activeFaqIndex === index}
                                            onToggle={() => setActiveFaqIndex(activeFaqIndex === index ? null : index)}
                                        />
                                    ))
                                ) : (
                                    <p className="text-center text-gray-500">No FAQs found.</p>
                                )}
                            </div>
                        }

                        {/* {practiceactiveTab === "more_details" &&
                            <div className="">
                                <ul className="space-y-3">
                                    <li className="text-dark flex flex-wrap items-center"><span className="font-semibold text-base min-w-56">AHPRA Number :</span><span>{practitionerDetails?.ahpra_number}</span></li>
                                    <li className="text-dark flex flex-wrap items-center"><span className="font-semibold text-base min-w-56">AHPRA Registration Date :</span><span>{formatDateForView(practitionerDetails?.ahpra_registration_date)}</span></li>
                                    <li className="text-dark flex flex-wrap items-center"><span className="font-semibold text-base min-w-56">AHPRA Expiry Date :</span><span>{formatDateForView(practitionerDetails?.ahpra_expiry_date)}</span></li>
                                    <li className="text-dark flex flex-wrap items-center"><span className="font-semibold text-base min-w-56">Gender :</span><span>{getGender(practitionerDetails?.gender)}</span></li>
                                    <li className="text-dark flex flex-wrap items-center"><span className="font-semibold text-base min-w-56">Languages  :</span><span>{practitionerDetails?.languages?.map(language => language.name).join(", ")}</span></li>
                                    <li className="text-dark flex flex-wrap items-center"><span className="font-semibold text-base min-w-56">Type of Practice :</span><span>{practitionerDetails?.practices_types?.map(practices_type => practices_type.name).join(", ")}</span></li>                                    
                                </ul>
                            </div>
                        } */}
                    </div>
                </div>
            </div>
        </>)
}

export default PractitionerDetailsCard;